import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { findIndex, reject, find } from "lodash"
import { formatPaginationParams } from "helpers/pagination"

import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// ACTIONS
const requested = createAction("boats/requested")
const received = createAction("boats/received")
const failed = createAction("boats/failed")
const cleaned = createAction("boats/cleaned")

const requestedBoat = createAction("boats/requestedBoat")
const receivedBoat = createAction("boats/receivedBoat")
const failedBoat = createAction("boats/failedBoat")

const createdBoat = createAction("boats/createdBoat")
const updatedBoat = createAction("boats/updatedBoat")
const deletedBoat = createAction("boats/deletedBoat")
const cleanedBoat = createAction("boats/cleanedBoat")

const requestedCustomInfo = createAction("boats/requestedCustomInfo")
const receivedCustomInfo = createAction("boats/receivedCustomInfo")
const failedCustomInfo = createAction("boats/failedCustomInfo")

const requestedSafety = createAction("boats/requestedSafety")
const receivedSafety = createAction("boats/receivedSafety")
const failedSafety = createAction("boats/failedSafety")

// Actions for category_to_boats endpoint
const requestedCategoryToBoats = createAction("boats/requestedCategoryToBoats")
const receivedCategoryToBoats = createAction("boats/receivedCategoryToBoats")
const failedCategoryToBoats = createAction("boats/failedCategoryToBoats")
// POST create/update mapping of categories to boats
const postedCategoryToBoats = createAction("boats/postedCategoryToBoats")
// Add PUT update action for single mapping update
const updatedCategoryToBoat = createAction("boats/updatedCategoryToBoat")
// Add DELETE action for single mapping removal
const deletedCategoryToBoat = createAction("boats/deletedCategoryToBoat")
// Add batch manage action for multiple operations
const batchManagedCategories = createAction("boats/batchManagedCategories")
// Add actions for checking duplicate category name
const requestedCheckDuplicateCategory = createAction("boats/requestedCheckDuplicateCategory")
const receivedCheckDuplicateCategory = createAction("boats/receivedCheckDuplicateCategory")
const failedCheckDuplicateCategory = createAction("boats/failedCheckDuplicateCategory")

// Add actions for checking duplicate category name (Add operation)
const requestedCheckDuplicateCategoryAdd = createAction("boats/requestedCheckDuplicateCategoryAdd")
const receivedCheckDuplicateCategoryAdd = createAction("boats/receivedCheckDuplicateCategoryAdd")
const failedCheckDuplicateCategoryAdd = createAction("boats/failedCheckDuplicateCategoryAdd")

// Add actions for checking duplicate category name (Edit operation)
const requestedCheckDuplicateCategoryEdit = createAction("boats/requestedCheckDuplicateCategoryEdit")
const receivedCheckDuplicateCategoryEdit = createAction("boats/receivedCheckDuplicateCategoryEdit")
const failedCheckDuplicateCategoryEdit = createAction("boats/failedCheckDuplicateCategoryEdit")

// Category management actions (individual operations)
const requestedAddCategory = createAction("boats/requestedAddCategory")
const receivedAddCategory = createAction("boats/receivedAddCategory")
const failedAddCategory = createAction("boats/failedAddCategory")

const requestedEditCategory = createAction("boats/requestedEditCategory")
const receivedEditCategory = createAction("boats/receivedEditCategory")
const failedEditCategory = createAction("boats/failedEditCategory")

const requestedDeleteCategory = createAction("boats/requestedDeleteCategory")
const receivedDeleteCategory = createAction("boats/receivedDeleteCategory")
const failedDeleteCategory = createAction("boats/failedDeleteCategory")

// Actions for characteristic_to_boats endpoint
const requestedCharacteristicToBoats = createAction("boats/requestedCharacteristicToBoats")
const receivedCharacteristicToBoats = createAction("boats/receivedCharacteristicToBoats")
const failedCharacteristicToBoats = createAction("boats/failedCharacteristicToBoats")

// Actions for asset_details endpoint
const requestedAssetDetails = createAction("boats/requestedAssetDetails")
const receivedAssetDetails = createAction("boats/receivedAssetDetails")
const failedAssetDetails = createAction("boats/failedAssetDetails")

// Actions for deactivate equipment
const requestedDeactivateEquipment = createAction("boats/requestedDeactivateEquipment")
const receivedDeactivateEquipment = createAction("boats/receivedDeactivateEquipment")
const failedDeactivateEquipment = createAction("boats/failedDeactivateEquipment")

// Actions for activate equipment
const requestedActivateEquipment = createAction("boats/requestedActivateEquipment")
const receivedActivateEquipment = createAction("boats/receivedActivateEquipment")
const failedActivateEquipment = createAction("boats/failedActivateEquipment")

// Actions for delete equipment
const requestedDeleteEquipment = createAction("boats/requestedDeleteEquipment")
const receivedDeleteEquipment = createAction("boats/receivedDeleteEquipment")
const failedDeleteEquipment = createAction("boats/failedDeleteEquipment")

// Actions for fetching equipment deactivation details
const requestedEquipmentDeactivationDetails = createAction("boats/requestedEquipmentDeactivationDetails")
const receivedEquipmentDeactivationDetails = createAction("boats/receivedEquipmentDeactivationDetails")
const failedEquipmentDeactivationDetails = createAction("boats/failedEquipmentDeactivationDetails")

// Actions for fetching equipment deletion details
const requestedEquipmentDeletionDetails = createAction("boats/requestedEquipmentDeletionDetails")
const receivedEquipmentDeletionDetails = createAction("boats/receivedEquipmentDeletionDetails")
const failedEquipmentDeletionDetails = createAction("boats/failedEquipmentDeletionDetails")

// Actions for asset deactivation check and execute
const requestedAssetDeactivationCheck = createAction("boats/requestedAssetDeactivationCheck")
const receivedAssetDeactivationCheck = createAction("boats/receivedAssetDeactivationCheck")
const failedAssetDeactivationCheck = createAction("boats/failedAssetDeactivationCheck")

const requestedDeactivateAsset = createAction("boats/requestedDeactivateAsset")
const receivedDeactivateAsset = createAction("boats/receivedDeactivateAsset")
const failedDeactivateAsset = createAction("boats/failedDeactivateAsset")

const requestedActivateAsset = createAction("boats/requestedActivateAsset")
const receivedActivateAsset = createAction("boats/receivedActivateAsset")
const failedActivateAsset = createAction("boats/failedActivateAsset")

// Actions for asset deletion check and execute
const requestedAssetDeletionCheck = createAction("boats/requestedAssetDeletionCheck")
const receivedAssetDeletionCheck = createAction("boats/receivedAssetDeletionCheck")
const failedAssetDeletionCheck = createAction("boats/failedAssetDeletionCheck")

const requestedDeleteAsset = createAction("boats/requestedDeleteAsset")
const receivedDeleteAsset = createAction("boats/receivedDeleteAsset")
const failedDeleteAsset = createAction("boats/failedDeleteAsset")

// Actions for equipment details
const requestedEquipmentDetails = createAction("boats/requestedEquipmentDetails")
const receivedEquipmentDetails = createAction("boats/receivedEquipmentDetails")
const failedEquipmentDetails = createAction("boats/failedEquipmentDetails")
const cleanedEquipmentDetails = createAction("boats/cleanedEquipmentDetails")

// Actions for equipment calendar
const requestedEquipmentCalendar = createAction("boats/requestedEquipmentCalendar")
const receivedEquipmentCalendar = createAction("boats/receivedEquipmentCalendar")
const failedEquipmentCalendar = createAction("boats/failedEquipmentCalendar")

const requestedTrips = createAction("trips/requested")
const receivedTrips = createAction("trips/received")
const failedTrips = createAction("trips/failed")

// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  items: [],
  custom_info: {
    ...LOADING_INITIAL_STATE,
    items: []
  },
  safety: {
    ...LOADING_INITIAL_STATE,
    items: []
  },
  metadata: {
    page: null,
    total_pages: null,
    total_results: null,
    next_page: null,
    prev_page: null
  },
  category_to_boats: {
    ...LOADING_INITIAL_STATE,
    items: [],
    metadata: {
      page: null,
      total_pages: null,
      total_results: null,
      next_page: null,
      prev_page: null
    }
  },
  characteristic_to_boats: {
    ...LOADING_INITIAL_STATE,
    items: [],
    metadata: {
      page: null,
      total_pages: null,
      total_results: null,
      next_page: null,
      prev_page: null
    }
  },
  asset_details: {
    ...LOADING_INITIAL_STATE,
    items: []
  },
  boat: {
    ...LOADING_INITIAL_STATE,
    id: null,
    guide_id: null,
    name: "",
    description: "",
    custom_info: [],
    safety: [],
    properties: [],
    version: 0
  },
  deactivate_equipment: {
    ...LOADING_INITIAL_STATE
  },
  activate_equipment: {
    ...LOADING_INITIAL_STATE
  },
  delete_equipment: {
    ...LOADING_INITIAL_STATE
  },
  equipment_deactivation_details: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  equipment_deletion_details: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  check_duplicate_category: {
    ...LOADING_INITIAL_STATE,
    is_unique: null
  },
  check_duplicate_category_add: {
    ...LOADING_INITIAL_STATE,
    is_unique: null
  },
  check_duplicate_category_edit: {
    ...LOADING_INITIAL_STATE,
    is_unique: null
  },
  add_category: {
    ...LOADING_INITIAL_STATE
  },
  edit_category: {
    ...LOADING_INITIAL_STATE
  },
  delete_category: {
    ...LOADING_INITIAL_STATE
  },
  asset_deactivation_check: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  deactivate_asset: {
    ...LOADING_INITIAL_STATE
  },
  activate_asset: {
    ...LOADING_INITIAL_STATE
  },
  asset_deletion_check: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  delete_asset: {
    ...LOADING_INITIAL_STATE
  },
  equipment_details: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  equipment_calendar: {
    ...LOADING_INITIAL_STATE,
    data: null,
    journalNoteDates: []
  }
}

const boatsReducer = createReducer(initialState, {
  [requested.type]: (state) => {
    setRequested(state)
  },
  [received.type]: (state, action) => {
    setReceived(state)
    state.items = action.payload.data
    Object.assign(state.metadata, action.payload.metadata)
  },
  [failed.type]: (state) => {
    setFailed(state)
  },
  // category_to_boats reducer cases
  [requestedCategoryToBoats.type]: (state) => {
    setRequested(state.category_to_boats)
  },
  [receivedCategoryToBoats.type]: (state, action) => {
    setReceived(state.category_to_boats)
    state.category_to_boats.items = action.payload.data
    Object.assign(state.category_to_boats.metadata, action.payload.metadata)
  },
  [failedCategoryToBoats.type]: (state) => {
    setFailed(state.category_to_boats)
  },
  [postedCategoryToBoats.type]: (state, action) => {
    // Assume API returns updated mapping list similar to GET shape (data, metadata optional)
    setReceived(state.category_to_boats)
    if (Array.isArray(action.payload?.data)) state.category_to_boats.items = action.payload.data
    if (action.payload?.metadata) Object.assign(state.category_to_boats.metadata, action.payload.metadata)
  },
  [updatedCategoryToBoat.type]: (state, action) => {
    // Update single boat's category mapping locally if backend returns updated mapping object
    // Expected action.payload: { id, category_id, boat_id, ... }
    setReceived(state.category_to_boats)
    const itemIndex = state.category_to_boats.items.findIndex((m) => m.id === action.payload?.id)
    if (itemIndex >= 0) {
      Object.assign(state.category_to_boats.items[itemIndex], action.payload)
    } else if (action.payload) {
      // If backend returns full list vs single object we skip this branch
      if (!Array.isArray(action.payload)) state.category_to_boats.items.push(action.payload)
    }
  },
  [deletedCategoryToBoat.type]: (state, action) => {
    // Remove a mapping by id; backend expected to return at least { id } of deleted mapping
    setReceived(state.category_to_boats)
    const id = action.payload?.id
    if (id !== undefined && id !== null) {
      state.category_to_boats.items = state.category_to_boats.items.filter((m) => m.id !== id)
    }
    // Alternatively if backend returns refreshed list: { data: [...] }
    if (Array.isArray(action.payload?.data)) {
      state.category_to_boats.items = action.payload.data
    }
  },
  // characteristic_to_boats reducer cases
  [requestedCharacteristicToBoats.type]: (state) => {
    setRequested(state.characteristic_to_boats)
  },
  [receivedCharacteristicToBoats.type]: (state, action) => {
    setReceived(state.characteristic_to_boats)
    if (action.payload?.data) state.characteristic_to_boats.items = action.payload.data
    if (action.payload?.metadata) Object.assign(state.characteristic_to_boats.metadata, action.payload.metadata)
  },
  [failedCharacteristicToBoats.type]: (state) => {
    setFailed(state.characteristic_to_boats)
  },
  // asset_details reducer cases
  [requestedAssetDetails.type]: (state) => {
    setRequested(state.asset_details)
  },
  [receivedAssetDetails.type]: (state, action) => {
    setReceived(state.asset_details)
    state.asset_details.items = action.payload.data
  },
  [failedAssetDetails.type]: (state) => {
    setFailed(state.asset_details)
  },
  // deactivate equipment reducer cases
  [requestedDeactivateEquipment.type]: (state) => {
    setRequested(state.deactivate_equipment)
  },
  [receivedDeactivateEquipment.type]: (state, action) => {
    setReceived(state.deactivate_equipment)
  },
  [failedDeactivateEquipment.type]: (state) => {
    setFailed(state.deactivate_equipment)
  },
  // activate equipment reducer cases
  [requestedActivateEquipment.type]: (state) => {
    setRequested(state.activate_equipment)
  },
  [receivedActivateEquipment.type]: (state, action) => {
    setReceived(state.activate_equipment)
  },
  [failedActivateEquipment.type]: (state) => {
    setFailed(state.activate_equipment)
  },
  // delete equipment reducer cases
  [requestedDeleteEquipment.type]: (state) => {
    setRequested(state.delete_equipment)
  },
  [receivedDeleteEquipment.type]: (state, action) => {
    setReceived(state.delete_equipment)
    // Remove the boat from items list (API response uses boat_id)
    const boatId = action.payload.boat_id || action.payload.id
    state.items = reject(state.items, ["id", boatId])
    // Clear current boat if it matches
    if (state.boat.id === boatId) {
      state.boat = initialState.boat
    }
  },
  [failedDeleteEquipment.type]: (state) => {
    setFailed(state.delete_equipment)
  },
  // equipment deactivation details reducer cases
  [requestedEquipmentDeactivationDetails.type]: (state) => {
    setRequested(state.equipment_deactivation_details)
  },
  [receivedEquipmentDeactivationDetails.type]: (state, action) => {
    setReceived(state.equipment_deactivation_details)
    state.equipment_deactivation_details.data = action.payload
  },
  [failedEquipmentDeactivationDetails.type]: (state) => {
    setFailed(state.equipment_deactivation_details)
  },
  // equipment deletion details reducer cases
  [requestedEquipmentDeletionDetails.type]: (state) => {
    setRequested(state.equipment_deletion_details)
  },
  [receivedEquipmentDeletionDetails.type]: (state, action) => {
    setReceived(state.equipment_deletion_details)
    state.equipment_deletion_details.data = action.payload
  },
  [failedEquipmentDeletionDetails.type]: (state) => {
    setFailed(state.equipment_deletion_details)
  },
  // check duplicate category reducer cases
  [requestedCheckDuplicateCategory.type]: (state) => {
    setRequested(state.check_duplicate_category)
  },
  [receivedCheckDuplicateCategory.type]: (state, action) => {
    setReceived(state.check_duplicate_category)
    state.check_duplicate_category.is_unique = action.payload.is_unique
  },
  [failedCheckDuplicateCategory.type]: (state) => {
    setFailed(state.check_duplicate_category)
    state.check_duplicate_category.is_unique = null
  },
  // check duplicate category Add reducer cases
  [requestedCheckDuplicateCategoryAdd.type]: (state) => {
    setRequested(state.check_duplicate_category_add)
  },
  [receivedCheckDuplicateCategoryAdd.type]: (state, action) => {
    setReceived(state.check_duplicate_category_add)
    state.check_duplicate_category_add.is_unique = action.payload.is_unique
  },
  [failedCheckDuplicateCategoryAdd.type]: (state) => {
    setFailed(state.check_duplicate_category_add)
    state.check_duplicate_category_add.is_unique = null
  },
  // check duplicate category Edit reducer cases
  [requestedCheckDuplicateCategoryEdit.type]: (state) => {
    setRequested(state.check_duplicate_category_edit)
  },
  [receivedCheckDuplicateCategoryEdit.type]: (state, action) => {
    setReceived(state.check_duplicate_category_edit)
    state.check_duplicate_category_edit.is_unique = action.payload.is_unique
  },
  [failedCheckDuplicateCategoryEdit.type]: (state) => {
    setFailed(state.check_duplicate_category_edit)
    state.check_duplicate_category_edit.is_unique = null
  },
  // Add category reducer cases
  [requestedAddCategory.type]: (state) => {
    setRequested(state.add_category)
  },
  [receivedAddCategory.type]: (state, action) => {
    setReceived(state.add_category)
    // Add new category to list
    if (action.payload) {
      state.category_to_boats.items.push(action.payload)
    }
  },
  [failedAddCategory.type]: (state) => {
    setFailed(state.add_category)
  },
  // Edit category reducer cases
  [requestedEditCategory.type]: (state) => {
    setRequested(state.edit_category)
  },
  [receivedEditCategory.type]: (state, action) => {
    setReceived(state.edit_category)
    // Update category in list
    const index = state.category_to_boats.items.findIndex((c) => c.id === action.payload?.id)
    if (index >= 0) {
      state.category_to_boats.items[index] = action.payload
    }
  },
  [failedEditCategory.type]: (state) => {
    setFailed(state.edit_category)
  },
  // Delete category reducer cases
  [requestedDeleteCategory.type]: (state) => {
    setRequested(state.delete_category)
  },
  [receivedDeleteCategory.type]: (state, action) => {
    setReceived(state.delete_category)
    // Remove category from list
    const id = action.payload?.id || action.payload?.deleted_id
    if (id) {
      state.category_to_boats.items = state.category_to_boats.items.filter((c) => c.id !== id)
    }
  },
  [failedDeleteCategory.type]: (state) => {
    setFailed(state.delete_category)
  },
  // Asset Deactivation Check Reducers
  [requestedAssetDeactivationCheck.type]: (state) => {
    setRequested(state.asset_deactivation_check)
  },
  [receivedAssetDeactivationCheck.type]: (state, action) => {
    setReceived(state.asset_deactivation_check)
    state.asset_deactivation_check.data = action.payload
  },
  [failedAssetDeactivationCheck.type]: (state) => {
    setFailed(state.asset_deactivation_check)
  },
  // Deactivate Asset Reducers
  [requestedDeactivateAsset.type]: (state) => {
    setRequested(state.deactivate_asset)
  },
  [receivedDeactivateAsset.type]: (state) => {
    setReceived(state.deactivate_asset)
  },
  [failedDeactivateAsset.type]: (state) => {
    setFailed(state.deactivate_asset)
  },
  // Activate Asset Reducers
  [requestedActivateAsset.type]: (state) => {
    setRequested(state.activate_asset)
  },
  [receivedActivateAsset.type]: (state) => {
    setReceived(state.activate_asset)
  },
  [failedActivateAsset.type]: (state) => {
    setFailed(state.activate_asset)
  },
  // Asset Deletion Check Reducers
  [requestedAssetDeletionCheck.type]: (state) => {
    setRequested(state.asset_deletion_check)
  },
  [receivedAssetDeletionCheck.type]: (state, action) => {
    setReceived(state.asset_deletion_check)
    state.asset_deletion_check.data = action.payload
  },
  [failedAssetDeletionCheck.type]: (state) => {
    setFailed(state.asset_deletion_check)
  },
  // Delete Asset Reducers
  [requestedDeleteAsset.type]: (state) => {
    setRequested(state.delete_asset)
  },
  [receivedDeleteAsset.type]: (state) => {
    setReceived(state.delete_asset)
  },
  [failedDeleteAsset.type]: (state) => {
    setFailed(state.delete_asset)
  },
  // Equipment details reducer cases
  [requestedEquipmentDetails.type]: (state) => {
    setRequested(state.equipment_details)
  },
  [receivedEquipmentDetails.type]: (state, action) => {
    setReceived(state.equipment_details)
    state.equipment_details.data = action.payload
  },
  [failedEquipmentDetails.type]: (state) => {
    setFailed(state.equipment_details)
  },
  [cleanedEquipmentDetails.type]: (state) => {
    state.equipment_details = initialState.equipment_details
  },
  // Equipment calendar reducer cases
  [requestedEquipmentCalendar.type]: (state) => {
    setRequested(state.equipment_calendar)
  },
  [receivedEquipmentCalendar.type]: (state, action) => {
    setReceived(state.equipment_calendar)
    state.equipment_calendar.data = action.payload
    state.equipment_calendar.journalNoteDates = action.payload?.data?.journal_note_dates || []
  },
  [failedEquipmentCalendar.type]: (state) => {
    setFailed(state.equipment_calendar)
  },
  [cleaned.type]: () => initialState,
  [requestedBoat.type]: (state) => {
    setRequested(state.boat)
  },
  [receivedBoat.type]: (state, action) => {
    setReceived(state.boat)
    // Merge payload into existing boat object to preserve loading flags (loading, loaded, etc.) from LOADING_INITIAL_STATE
    Object.assign(state.boat, action.payload)
    state.boat.version = (state.boat.version || 0) + 1
  },
  [createdBoat.type]: (state, action) => {
    setReceived(state.boat)
    state.items = [action.payload, ...state.items]
    Object.assign(state.boat, action.payload)
    state.boat.version = (state.boat.version || 0) + 1
  },
  [updatedBoat.type]: (state, action) => {
    setReceived(state.boat)
    const postIndex = findIndex(state.items, ["id", action.payload.id])

    if (postIndex >= 0) Object.assign(state.items[postIndex], action.payload)
    Object.assign(state.boat, action.payload)
    state.boat.version = (state.boat.version || 0) + 1
  },
  [deletedBoat.type]: (state, action) => {
    setReceived(state.boat)
    state.items = reject(state.items, ["id", action.payload.id])
  },
  [failedBoat.type]: (state) => {
    setFailed(state.boat)
  },
  [cleanedBoat.type]: (state) => {
    state.boat = initialState.boat
  },
  [requestedCustomInfo.type]: (state) => {
    setRequested(state.custom_info)
  },
  [receivedCustomInfo.type]: (state, action) => {
    setReceived(state.custom_info)
    state.custom_info.items = action.payload.data
  },
  [failedCustomInfo.type]: (state) => {
    setFailed(state.custom_info)
  },
  [requestedSafety.type]: (state) => {
    setRequested(state.safety)
  },
  [receivedSafety.type]: (state, action) => {
    setReceived(state.safety)
    state.safety.items = action.payload.data
  },
  [failedSafety.type]: (state) => {
    setFailed(state.safety)
  }
})
export default boatsReducer

const getItems = (url, nextPage, dispatch, getState, customActions, params = {}) => {
  const state = getState()
  let metadata = state.boats.metadata
  let onStart = requested.type
  let onSuccess = received.type
  let onError = failed.type
  if (customActions) {
    metadata = state.boats[customActions.stateKey]?.metadata || metadata
    onStart = customActions.onStart
    onSuccess = customActions.onSuccess
    onError = customActions.onError
  }
  const paginationParams = formatPaginationParams(metadata, nextPage)
  return dispatch(
    api({
      url,
      onStart,
      onSuccess,
      onError,
      params: { ...paginationParams, ...params },
      props: { reset: !nextPage }
    })
  )
}

const getItem = (url, id, dispatch, getState) => {
  const state = getState()
  const boat = find(state.boats.items, ["id", +id])

  if (boat) {
    dispatch(receivedBoat(boat))
    return Promise.resolve(boat)
  }
  return dispatch(
    api({
      url,
      onStart: requestedBoat.type,
      onSuccess: receivedBoat.type,
      onError: failedBoat.type
    })
  )
}

export const getGuideBoats = (nextPage, params) => (dispatch, getState) =>
  getItems("/guide/boats", nextPage, dispatch, getState, undefined, params)

export const getGuideBoat = (id) => (dispatch, getState) => getItem(`/guide/boats/${id}`, id, dispatch, getState)

// Generic getter by id for a single boat (alias of getGuideBoat) so other features can use a semantic name
// Usage: dispatch(getBoatById(39)) -> calls /guide/boats/39 and stores result in state.boats.boat
export const getBoatById = (id) => (dispatch, getState) => getItem(`/guide/boats/${id}`, id, dispatch, getState)

// Uncached fetch that always hits the API even if boat exists in items array.
// Useful when needing fresh data & proper loading state (e.g., editing modal).
export const fetchBoatById = (id) => (dispatch) => {
  return dispatch(
    api({
      url: `/guide/boats/${id}`,
      onStart: requestedBoat.type,
      onSuccess: receivedBoat.type,
      onError: failedBoat.type
    })
  )
}

export const getClientGuideBoats = (id, nextPage, params) => (dispatch, getState) =>
  getItems(`/client/guides/${id}/boats`, nextPage, dispatch, getState, undefined, params)

export const getTrips = (nextPage, params) => (dispatch, getState) => {
  const state = getState()
  const paginationParams = formatPaginationParams(state.boats?.metadata, nextPage)
  return dispatch(
    api({
      url: "/guide/boats/trips",
      onStart: requestedTrips.type,
      onSuccess: receivedTrips.type,
      onError: failedTrips.type,
      params: { ...paginationParams, ...params },
      props: { reset: !nextPage }
    })
  )
}

export const createBoat = (data) =>
  api({
    url: "/guide/boats",
    method: "post",
    onStart: requestedBoat.type,
    onSuccess: createdBoat.type,
    onError: failedBoat.type,
    data
  })

export const updateBoat = (id, data) =>
  api({
    url: `/guide/boats/${id}`,
    method: "put",
    data: data,
    onStart: requestedBoat.type,
    onSuccess: updatedBoat.type,
    onError: failedBoat.type
  })

export const saveBoat = (id, data) => (id ? updateBoat(id, data) : createBoat(data))

export const deleteBoat = (id) =>
  api({
    url: `/guide/boats/${id}`,
    method: "delete",
    onStart: requestedBoat.type,
    onSuccess: deletedBoat.type,
    onError: failedBoat.type
  })

export const getCustomInfo = () =>
  api({
    url: `/guide/boats/custom_info`,
    onStart: requestedCustomInfo.type,
    onSuccess: receivedCustomInfo.type,
    onError: failedCustomInfo.type
  })

export const getSafety = () =>
  api({
    url: `/guide/boats/safety`,
    onStart: requestedSafety.type,
    onSuccess: receivedSafety.type,
    onError: failedSafety.type
  })
export const getGuideBoatsListing = (nextPage, params) => (dispatch, getState) =>
  getItems("/guide/boats/listing", nextPage, dispatch, getState, undefined, params)

// Action for /guide/boats/category_to_boats endpoint
export const getGuideCategoryToBoats = (nextPage, params) => (dispatch, getState) =>
  getItems(
    "/guide/boats/category_to_boats",
    nextPage,
    dispatch,
    getState,
    {
      onStart: requestedCategoryToBoats.type,
      onSuccess: receivedCategoryToBoats.type,
      onError: failedCategoryToBoats.type,
      stateKey: "category_to_boats"
    },
    params
  )

// Action for /guide/boats/characteristic_to_boats endpoint (no pagination / params required)
export const getGuideCharacteristicToBoats = () =>
  api({
    url: "/guide/boats/characteristic_to_boats",
    onStart: requestedCharacteristicToBoats.type,
    onSuccess: receivedCharacteristicToBoats.type,
    onError: failedCharacteristicToBoats.type
  })

// Action for /guide/boats/asset_details endpoint
export const getGuideBoatsAssetDetails = () =>
  api({
    url: "/guide/boats/asset_details",
    onStart: requestedAssetDetails.type,
    onSuccess: receivedAssetDetails.type,
    onError: failedAssetDetails.type
  })

// POST action for /guide/boats/category_to_boats
// Expects 'data' shaped per backend requirements (e.g., { category_id, boat_ids: [] })
// Usage: dispatch(createGuideCategoryToBoats({ category_id: 1, boat_ids: [3,4] }))
export const createGuideCategoryToBoats = (data) =>
  api({
    url: "/guide/boats/create_category_to_boat",
    method: "post",
    data,
    onStart: requestedCategoryToBoats.type,
    onSuccess: postedCategoryToBoats.type,
    onError: failedCategoryToBoats.type
  })

export const updateGuideCategoryToBoat = (id, data) =>
  api({
    url: `/guide/boats/update_category_to_boat/${id}`,
    method: "put",
    data,
    onStart: requestedCategoryToBoats.type,
    onSuccess: updatedCategoryToBoat.type,
    onError: failedCategoryToBoats.type
  })

export const deleteGuideCategoryToBoat = (id) =>
  api({
    url: `/guide/boats/destroy_category_to_boat/${id}`,
    method: "delete",
    onStart: requestedCategoryToBoats.type,
    onSuccess: deletedCategoryToBoat.type,
    onError: failedCategoryToBoats.type
  })

export const batchManageCategories = (data) =>
  api({
    url: "/guide/boats/batch_manage_categories",
    method: "post",
    data,
    onStart: requestedCategoryToBoats.type,
    onSuccess: batchManagedCategories.type,
    onError: failedCategoryToBoats.type
  })

export const checkDuplicateCategoryName = (name) =>
  api({
    url: "/guide/boats/check_duplicate_category_name",
    method: "get",
    params: { name },
    onStart: requestedCheckDuplicateCategory.type,
    onSuccess: receivedCheckDuplicateCategory.type,
    onError: failedCheckDuplicateCategory.type
  })

export const checkDuplicateCategoryNameAdd = (name) =>
  api({
    url: "/guide/boats/check_duplicate_category_name",
    method: "get",
    params: { name },
    onStart: requestedCheckDuplicateCategoryAdd.type,
    onSuccess: receivedCheckDuplicateCategoryAdd.type,
    onError: failedCheckDuplicateCategoryAdd.type
  })

export const checkDuplicateCategoryNameEdit = (name) =>
  api({
    url: "/guide/boats/check_duplicate_category_name",
    method: "get",
    params: { name },
    onStart: requestedCheckDuplicateCategoryEdit.type,
    onSuccess: receivedCheckDuplicateCategoryEdit.type,
    onError: failedCheckDuplicateCategoryEdit.type
  })

// Category management API functions
export const addCategory = (data) =>
  api({
    url: "/guide/boats/categories",
    method: "post",
    data,
    onStart: requestedAddCategory.type,
    onSuccess: receivedAddCategory.type,
    onError: failedAddCategory.type
  })

export const editCategory = (id, data) =>
  api({
    url: `/guide/boats/categories/${id}`,
    method: "put",
    data,
    onStart: requestedEditCategory.type,
    onSuccess: receivedEditCategory.type,
    onError: failedEditCategory.type
  })

export const deleteCategory = (id, data) =>
  api({
    url: `/guide/boats/categories/${id}`,
    method: "delete",
    data, // Contains move_to_category_id if needed
    onStart: requestedDeleteCategory.type,
    onSuccess: receivedDeleteCategory.type,
    onError: failedDeleteCategory.type
  })

export const cleanBoats = () => (dispatch) => dispatch(cleaned())
export const cleanBoat = () => (dispatch) => dispatch(cleanedBoat())
export const cleanEquipmentDetails = () => (dispatch) => dispatch(cleanedEquipmentDetails())

/**
 * Deactivate equipment
 * @param {number} id - Equipment ID
 * @param {object} data - Request payload with mode and additional data
 * @param {string} data.mode - One of EQUIPMENT_DELETE_DEACTIVATE_MODES
 * @param {array} data.replacement_ids - Array of replacement equipment IDs (for partially substitutable)
 *
 * Endpoint will be provided by backend team
 * Example: POST /guide/boats/:id/deactivate
 */
export const deactivateEquipment = (id, data) =>
  api({
    url: `/guide/boats/${id}/deactivate`,
    method: "post",
    data,
    onStart: requestedDeactivateEquipment.type,
    onSuccess: receivedDeactivateEquipment.type,
    onError: failedDeactivateEquipment.type
  })

/**
 * Activate equipment
 * @param {number} id - Equipment ID
 * @param {object} data - Request payload (optional)
 *
 * Endpoint: POST /api/guide/boats/:id/activate
 */
export const activateEquipment = (id, data) =>
  api({
    url: `/guide/boats/${id}/activate`,
    method: "post",
    data,
    onStart: requestedActivateEquipment.type,
    onSuccess: receivedActivateEquipment.type,
    onError: failedActivateEquipment.type
  })

/**
 * Delete equipment
 * @param {number} id - Equipment ID
 * @param {object} data - Request payload with mode and additional data
 * @param {string} data.mode - One of EQUIPMENT_DELETE_DEACTIVATE_MODES
 * @param {array} data.replacement_ids - Array of replacement equipment IDs (for partially substitutable)
 *
 * Endpoint will be provided by backend team
 * Example: DELETE /guide/boats/:id or POST /guide/boats/:id/delete
 */
export const deleteEquipment = (id, data) =>
  api({
    url: `/guide/boats/${id}`,
    method: "delete",
    data,
    onStart: requestedDeleteEquipment.type,
    onSuccess: receivedDeleteEquipment.type,
    onError: failedDeleteEquipment.type
  })

// Selectors
export const selectCharacteristicToBoats = (state) => state.boats.characteristic_to_boats.items
export const selectCharacteristicToBoatsLoading = (state) => state.boats.characteristic_to_boats.loading
export const selectCharacteristicToBoatsMetadata = (state) => state.boats.characteristic_to_boats.metadata

/**
 * Fetch equipment deactivation details
 * Gets detailed information needed to show the correct deactivation modal
 * @param {number} id - Equipment ID
 *
 * Response structure:
 * {
 *   success: boolean,
 *   can_deactivate: boolean,
 *   status: string, // "no_experiences_assigned" | "no_active_bookings" | "fully_substitutable" | "partially_substitutable"
 *   boat_id: number,
 *   boat_name: string,
 *   assigned_trips: [{ trip_id, trip_name, trip_category, guide_name, min_guests, max_guests }],
 *   active_bookings: [{
 *     booking_id, booking_uuid, experience_name, client_name, date_range, start_time, end_time,
 *     status, guest_count, assets_needed, available_substitutes: [{ boat_id, boat_name, capacity, available_assets }],
 *     can_substitute: boolean
 *   }],
 *   requires_substitution: boolean,
 *   blocking_bookings: [] // Present when can_deactivate is false
 * }
 *
 * Endpoint: POST /guide/boats/:id/check_deactivation
 */
export const getEquipmentDeactivationDetails = (id) =>
  api({
    url: `/guide/boats/${id}/check_deactivation`,
    method: "post",
    onStart: requestedEquipmentDeactivationDetails.type,
    onSuccess: receivedEquipmentDeactivationDetails.type,
    onError: failedEquipmentDeactivationDetails.type
  })

/**
 * Fetch equipment deletion details
 * Gets detailed information needed to show the correct deletion modal
 * @param {number} id - Equipment ID
 *
 * Response structure:
 * {
 *   success: boolean,
 *   can_delete: boolean,
 *   status: string, // "can_delete" | "can_delete_with_trips" | "fully_substitutable" | "partially_substitutable"
 *   mode: string, // "no_dependencies" | "has_trips_no_bookings" | "fully_substitutable" | "partially_substitutable"
 *   message: string,
 *   boat_id: number,
 *   boat_name: string,
 *   assigned_trips: [{ trip_id, trip_uuid, trip_name, trip_category, guide_name, min_guests, max_guests }],
 *   active_bookings: [{
 *     booking_id, booking_uuid, experience_name, client_name, date_range, start_time, end_time,
 *     status, guest_count, assets_needed, available_substitutes: [{ boat_id, boat_name, capacity, available_assets }],
 *     can_substitute: boolean
 *   }],
 *   blocking_bookings: [] // Present when can_delete is false
 * }
 *
 * Endpoint: GET /guide/boats/:id/check_deletion
 */
export const getEquipmentDeletionDetails = (id) =>
  api({
    url: `/guide/boats/${id}/check_deletion`,
    method: "get",
    onStart: requestedEquipmentDeletionDetails.type,
    onSuccess: receivedEquipmentDeletionDetails.type,
    onError: failedEquipmentDeletionDetails.type
  })

export const checkAssetDeactivation = (id) =>
  api({
    url: `/guide/boat_assets/${id}/check_deactivation`,
    method: "get",
    onStart: requestedAssetDeactivationCheck.type,
    onSuccess: receivedAssetDeactivationCheck.type,
    onError: failedAssetDeactivationCheck.type
  })

export const deactivateAsset = (id, data) =>
  api({
    url: `/guide/boat_assets/${id}/deactivate`,
    method: "post",
    data,
    onStart: requestedDeactivateAsset.type,
    onSuccess: receivedDeactivateAsset.type,
    onError: failedDeactivateAsset.type
  })

export const activateAsset = (id, data) =>
  api({
    url: `/guide/boat_assets/${id}/activate`,
    method: "post",
    data,
    onStart: requestedActivateAsset.type,
    onSuccess: receivedActivateAsset.type,
    onError: failedActivateAsset.type
  })

export const checkAssetDeletion = (id) =>
  api({
    url: `/guide/boat_assets/${id}/check_deletion`,
    method: "get",
    onStart: requestedAssetDeletionCheck.type,
    onSuccess: receivedAssetDeletionCheck.type,
    onError: failedAssetDeletionCheck.type
  })

export const deleteAsset = (boatId, assetId, data) =>
  api({
    url: `/guide/boats/${boatId}/boat_assets/${assetId}`,
    method: "delete",
    data,
    onStart: requestedDeleteAsset.type,
    onSuccess: receivedDeleteAsset.type,
    onError: failedDeleteAsset.type
  })

// Deactivate/Delete equipment selectors
export const selectDeactivateEquipmentLoading = (state) => state.boats.deactivate_equipment.loading
export const selectActivateEquipmentLoading = (state) => state.boats.activate_equipment.loading
export const selectDeleteEquipmentLoading = (state) => state.boats.delete_equipment.loading

// Main selector - use this in most cases
export const selectEquipmentDeactivationDetails = (state) => state.boats.equipment_deactivation_details.data
export const selectEquipmentDeactivationDetailsLoading = (state) => state.boats.equipment_deactivation_details.loading

// Convenience selectors for commonly accessed fields with safe defaults
export const selectAssignedTrips = (state) => state.boats.equipment_deactivation_details.data?.assigned_trips || []
export const selectActiveBookings = (state) => state.boats.equipment_deactivation_details.data?.active_bookings || []
export const selectBlockingBookings = (state) => state.boats.equipment_deactivation_details.data?.blocking_bookings || []

// Equipment deletion details selectors
export const selectEquipmentDeletionDetails = (state) => state.boats.equipment_deletion_details.data
export const selectEquipmentDeletionDetailsLoading = (state) => state.boats.equipment_deletion_details.loading

export const selectAssetDeactivationCheck = (state) => state.boats.asset_deactivation_check.data
export const selectAssetDeactivationCheckLoading = (state) => state.boats.asset_deactivation_check.loading
export const selectDeactivateAssetLoading = (state) => state.boats.deactivate_asset.loading
export const selectActivateAssetLoading = (state) => state.boats.activate_asset.loading

export const selectAssetDeletionCheck = (state) => state.boats.asset_deletion_check.data
export const selectAssetDeletionCheckLoading = (state) => state.boats.asset_deletion_check.loading
export const selectDeleteAssetLoading = (state) => state.boats.delete_asset.loading

/**
 * Fetch equipment details
 * GET /api/v1/guide/boats/:equipment_id/details
 */
export const getEquipmentDetails = (equipmentId) =>
  api({
    url: `/guide/boats/${equipmentId}/details`,
    method: "get",
    onStart: requestedEquipmentDetails.type,
    onSuccess: receivedEquipmentDetails.type,
    onError: failedEquipmentDetails.type
  })

/**
 * Fetch equipment calendar
 * GET /api/v1/guide/boats/:equipment_id/calendar
 * @param {number} equipmentId - Equipment ID
 * @param {object} params - Query parameters
 * @param {string} params.view_type - "day", "week", or "month" (default: "week")
 * @param {string} params.date - Date in YYYY-MM-DD format (default: today)
 * @param {string} params.asset_filter - "all", "with_bookings", "without_bookings", or "single_asset" (default: "all")
 * @param {number} params.asset_id - Asset ID (required when asset_filter="single_asset")
 */
export const getEquipmentCalendar = (equipmentId, params = {}) =>
  api({
    url: `/guide/boats/${equipmentId}/calendar`,
    method: "get",
    params,
    onStart: requestedEquipmentCalendar.type,
    onSuccess: receivedEquipmentCalendar.type,
    onError: failedEquipmentCalendar.type
  })

// Equipment details selectors
export const selectEquipmentDetails = (state) => state.boats.equipment_details.data
export const selectEquipmentDetailsLoading = (state) => state.boats.equipment_details.loading

// Equipment calendar selectors
export const selectEquipmentCalendar = (state) => state.boats.equipment_calendar.data
export const selectEquipmentCalendarLoading = (state) => state.boats.equipment_calendar.loading
export const selectEquipmentJournalNoteDates = (state) => state.boats.equipment_calendar.journalNoteDates

// Category management selectors
export const selectAddCategoryLoading = (state) => state.boats.add_category.loading
export const selectEditCategoryLoading = (state) => state.boats.edit_category.loading
export const selectDeleteCategoryLoading = (state) => state.boats.delete_category.loading
